import { Badge, Avatar } from '@mui/material';
import history from '@history';
import { defaultGroupLogo, defaultTeamLogo, defaultOrgLogo } from 'app/configs/themesConfig';
import generateChannelUrl from "app/shared-components/channel/utils/generateChannelUrl";



function ChannelLogo(props) {
  let { channel, className, sx, disableClick, mode, unread} = props;
  const isPublic= mode == "public";
  const type= channel?.type;
  const useId = channel?.channelId ? channel.channelId : channel?.id;
  const useLogo= channel?.entity?.logoImageUrl ? channel.entity.logoImageUrl : 
                 channel?.logoImageUrl ? channel.logoImageUrl : 
                  type == 'team' ? defaultTeamLogo : 
                  type == 'organization' ? defaultOrgLogo : defaultGroupLogo;

  if (!channel) return null;
  
  const navigateToChannel= (event) => {
	  if (!disableClick){
		  const pathToChannel = generateChannelUrl(channel, isPublic);
		  if (pathToChannel) {
			  history.push({
				  pathname: pathToChannel,
			  });
			  event.stopPropagation();
			  event.preventDefault();
		  }
	  } 
  }
  
  if (!channel ) return null;
  if (type != 'team' && type != 'group' && type != 'organization') return null;

  
  return (
	  <div onClick={navigateToChannel}>
	     <Badge color="secondary" variant="dot" invisible={!unread}>         
		  <Avatar 
	              sx={sx}
	              className={className}
	              src={useLogo}
	              alt={channel.name}
	            >
	      </Avatar> 
	     </Badge>
      </div>
  );
  
}

 


export default ChannelLogo;